import { render, staticRenderFns } from "./ms-update-drug.vue?vue&type=template&id=c8fd3358&scoped=true"
import script from "./ms-update-drug.vue?vue&type=script&lang=js"
export * from "./ms-update-drug.vue?vue&type=script&lang=js"
import style0 from "./ms-update-drug.vue?vue&type=style&index=0&id=c8fd3358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd3358",
  null
  
)

export default component.exports